/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChallengeFaqDetails
 */
export interface ChallengeFaqDetails {
    /**
     * 
     * @type {string}
     * @memberof ChallengeFaqDetails
     */
    question: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeFaqDetails
     */
    answer: string;
    /**
     * Optional section label used to group consecutive FAQs under a shared header (e.g. "How to Participate", "Rewards & How to Unlock Them"). When unset, the FAQ renders ungrouped. Adjacent FAQs sharing the same section value collapse into one labeled block on the hub UI.
     * @type {string}
     * @memberof ChallengeFaqDetails
     */
    section?: string;
}

/**
 * Check if a given object implements the ChallengeFaqDetails interface.
 */
export function instanceOfChallengeFaqDetails(value: object): value is ChallengeFaqDetails {
    if (!('question' in value) || value['question'] === undefined) return false;
    if (!('answer' in value) || value['answer'] === undefined) return false;
    return true;
}

export function ChallengeFaqDetailsFromJSON(json: any): ChallengeFaqDetails {
    return ChallengeFaqDetailsFromJSONTyped(json, false);
}

export function ChallengeFaqDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeFaqDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'question': json['question'],
        'answer': json['answer'],
        'section': json['section'] == null ? undefined : json['section'],
    };
}

export function ChallengeFaqDetailsToJSON(json: any): ChallengeFaqDetails {
    return ChallengeFaqDetailsToJSONTyped(json, false);
}

export function ChallengeFaqDetailsToJSONTyped(value?: ChallengeFaqDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'question': value['question'],
        'answer': value['answer'],
        'section': value['section'],
    };
}

